import BrowserProtocol from 'farce/BrowserProtocol';
import React from 'react';
import createFarceRouter from './createFarceRouter';
import resolver from './resolver';
import { jsx as _jsx } from "react/jsx-runtime";
export default function createBrowserRouter(options) {
  var Router = createFarceRouter(Object.assign({}, options, {
    historyProtocol: new BrowserProtocol()
  }));
  function BrowserRouterInstance(props) {
    // @ts-ignore TODO: resolver will be always overwritten
    return /*#__PURE__*/_jsx(Router, Object.assign({
      resolver: resolver
    }, props));
  }
  return BrowserRouterInstance;
}